/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ResourceProvider = 'AWS' | 'GCP' | 'CWS' | 'GCVE' | 'VMCA' | 'CBC' | 'EVS';

export const ResourceProvider = {

    AWS: 'AWS' as ResourceProvider,

    GCP: 'GCP' as ResourceProvider,

    CWS: 'CWS' as ResourceProvider,

    GCVE: 'GCVE' as ResourceProvider,

    VMCA: 'VMCA' as ResourceProvider,

    CBC: 'CBC' as ResourceProvider,

    EVS: 'EVS' as ResourceProvider
};

